import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from 'react';
import './index.css';
import DiceMould from "./pages/DiceMould";
import App from "./pages/App";
import Homepage from "./pages/Homepage";
import Software from "./pages/SW";
import Hardware from "./pages/HW";
import Layout from "./pages/Layout";
import UeberUns from "./pages/UeberUns";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Homepage />} />
        <Route path="dicemould" element={<DiceMould />} />
        <Route path="app" element={<App />} />
        <Route path="soft" element={<Software />} />
        <Route path="hard" element={<Hardware />} />
        <Route path="UeberUns" element={<UeberUns />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
